import { ExtendedPricesWizardData } from '../components/PricesWizard/Controls/PricesWizardExtended/PricesWizardExtended';
import { SimplePricesWizardData } from '../components/PricesWizard/Controls/PricesWizardSimple/PricesWizardSimple';
import { PricesWizardType } from '../typings/inspector';

export const OPEN_PRICES_WIZARD = 'OPEN_PRICES_WIZARD';
export type OPEN_PRICES_WIZARD = typeof OPEN_PRICES_WIZARD;

export interface OpenPricesWizard {
    type: OPEN_PRICES_WIZARD;
}

export function openPricesWizard(): OpenPricesWizard {
    return {
        type: OPEN_PRICES_WIZARD
    };
}

export const CLOSE_PRICES_WIZARD = 'CLOSE_PRICES_WIZARD';
export type CLOSE_PRICES_WIZARD = typeof CLOSE_PRICES_WIZARD;

export interface ClosePricesWizard {
    type: CLOSE_PRICES_WIZARD;
}

export function closePricesWizard(): ClosePricesWizard {
    return {
        type: CLOSE_PRICES_WIZARD
    };
}

export const PRICES_WIZARD_SAVE_PRICES = 'PRICES_WIZARD_SAVE_PRICES';
export type PRICES_WIZARD_SAVE_PRICES = typeof PRICES_WIZARD_SAVE_PRICES;

export interface PricesWizardSavePrices {
    type: PRICES_WIZARD_SAVE_PRICES;
}

export function pricesWizardSavePrices(): PricesWizardSavePrices {
    return {
        type: PRICES_WIZARD_SAVE_PRICES
    };
}

export const PRICES_WIZARD_PRICES_SAVED = 'PRICES_WIZARD_DATA_SAVED';
export type PRICES_WIZARD_DATA_SAVED = typeof PRICES_WIZARD_PRICES_SAVED;

export interface PricesWizardPricesSaved {
    type: PRICES_WIZARD_DATA_SAVED;
}

export function pricesWizardPricesSaved(): PricesWizardPricesSaved {
    return {
        type: PRICES_WIZARD_PRICES_SAVED
    };
}

export const PRICES_WIZARD_GENERAL_ERROR = 'PRICES_WIZARD_GENERAL_ERROR';
export type PRICES_WIZARD_GENERAL_ERROR = typeof PRICES_WIZARD_GENERAL_ERROR;

export interface PricesWizardGeneralError {
    type: PRICES_WIZARD_GENERAL_ERROR;
    message: string;
}

export function pricesWizardGeneralError(message: string): PricesWizardGeneralError {
    return {
        type: PRICES_WIZARD_GENERAL_ERROR,
        message
    };
}

export const CHANGE_PRICES_WIZARD_TAB = 'CHANGE_PRICES_WIZARD_TAB';
export type CHANGE_PRICES_WIZARD_TAB = typeof CHANGE_PRICES_WIZARD_TAB;

export interface ChangePricesWizardTab {
    type: CHANGE_PRICES_WIZARD_TAB;
    tab: PricesWizardType;
}

export function changePricesWizardTab(tab: PricesWizardType): ChangePricesWizardTab {
    return {
        type: CHANGE_PRICES_WIZARD_TAB,
        tab
    };
}

export const UPDATE_PRICES_WIZARD_DATA = 'UPDATE_PRICES_WIZARD_DATA';
export type UPDATE_PRICES_WIZARD_DATA = typeof UPDATE_PRICES_WIZARD_DATA;

export interface UpdatePricesWizardData {
    type: UPDATE_PRICES_WIZARD_DATA;
    data: {
        simple: SimplePricesWizardData;
        extended: ExtendedPricesWizardData;
    };
}

export function updatePricesWizardData(data: {
    simple: SimplePricesWizardData;
    extended: ExtendedPricesWizardData;
}): UpdatePricesWizardData {
    return {
        type: UPDATE_PRICES_WIZARD_DATA,
        data
    };
}

export const CLEAR_PRICES_WIZARD_ERROR = 'CLEAR_PRICES_WIZARD_ERROR';
export type CLEAR_PRICES_WIZARD_ERROR = typeof CLEAR_PRICES_WIZARD_ERROR;

export interface ClearPricesWizardError {
    type: CLEAR_PRICES_WIZARD_ERROR;
}

export function clearPricesWizardError(): ClearPricesWizardError {
    return {
        type: CLEAR_PRICES_WIZARD_ERROR
    };
}

export type PricesWizardGridAction =
    | PricesWizardSavePrices
    | OpenPricesWizard
    | ClosePricesWizard
    | PricesWizardGeneralError
    | PricesWizardPricesSaved
    | ChangePricesWizardTab
    | UpdatePricesWizardData
    | ClearPricesWizardError;
